export default __webpack_public_path__ + "static/media/banner_2.4f0bdcfd.png";